export const forgotPassword = {
  form: {
    placeholder: "Your email here",
    submit: "Submit",
    success:
      "If this email matches the email for an active account, we will send a recovery link to the email provided.",
    title:
      "Enter your email address and we will send you <nobr>a link to reset your password.</nobr>",
  },
  signInLink: "Back to sign in",
  title: "Forgot your password?",
};
